import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

const Header = ({
  children, className, logo, appName,
}) => {
  const headerClass = useMemo(() => cns('application__header', className), [className]);
  return (
    <div className={headerClass}>
      <div className="application__logo">{logo || 'Servizi CGN'}</div>
      {children}
      { appName && (
        <div className="application__header-name">
          {appName}
        </div>
      ) }
    </div>
  );
};

Header.propTypes = {
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Permette di specificare cosa renderizzare
     * come logo da visualizzare invece di quello di default */
  logo: PropTypes.element,
  /** Icona (svg) con il nome dell'applicazione */
  appName: PropTypes.element,
};

Header.defaultProps = {
  children: null,
  className: '',
  logo: null,
  appName: null,
};

export default Header;
